import { matchPath } from 'react-router';
export const routes = {
    productDetailPage: '/painter/products/details/:asin',
    previewOrderPage: '/checkout/preview',
    paymentSeletctionPage: '/checkout/payment-selection',
    thankYouPage: '/checkout/confirm',
    creatorStorefrontPage: '/painter/content/:aci',
};
/**
 * Allowlist of route prefixes supported in Painter 2.0
 * Routes not starting with these prefixes will redirect to legacy Painter
 * TODO: Remove this allowlist once all pages are supported in 2.0
 */
export const SUPPORTED_ROUTE_PREFIXES = [
    routes.previewOrderPage,
    routes.paymentSeletctionPage,
    routes.thankYouPage,
    routes.productDetailPage,
];
// Check if the current route is supported in Painter 2.0
export const isRouteSupported = (pathname) => {
    return SUPPORTED_ROUTE_PREFIXES.some((prefix) => matchPath(prefix, pathname));
};
